// extracted by mini-css-extract-plugin
export var aircallIframe = "_jy-3";
export var fabContainer = "_jy-5";
export var fabRinging = "_jy-6";
export var loadingOverlay = "_jy-4";
export var pulse = "_jy-7";
export var widgetContent = "_jy-2";
export var widgetPanel = "_jy-0";
export var widgetPanelExpanded = "_jy-1";